import React from "react";
import { useQuickSightComputeOptimizer  } from "@/hooks/useComputeOptimizerReports";

const QuickSightAwsComputeOptimizerDashboard = () => {
  const { embedUrl } = useQuickSightComputeOptimizer ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsComputeOptimizerDashboard;
